import { createTransform } from 'redux-persist';
import { find } from 'lodash';

const filterMethod = (state) => {
  if (state.selectedProfileId) {
    const entity = find(state?.entities, (item) => item.id === state.selectedProfileId);

    if (!entity) {
      return {
        ids: [],
        entities: {},
        selectedProfileId: null,
        status: false,
      };
    }

    const sanitizedStateItem = {
      ...entity,
      zoomRef: null, // unset the zoomRef when persisting the profile to localstorage
    };

    return {
      ...state,
      status: false,
      ids: [state.selectedProfileId],
      entities: {
        [state.selectedProfileId]: sanitizedStateItem,
      },
    };
  }

  return {
    ids: [],
    entities: {},
    status: false,
    selectedProfileId: null,
  };
};

export const filterItems = createTransform(filterMethod, filterMethod, { whitelist: ['acts', 'venues'] });
